// Vuetify plugin configuration
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#6C3CF0',
          'on-primary': '#FFFFFF',
          'primary-darken-1': '#4A23B8',
          'primary-lighten-5': '#EEE8FF',
          secondary: '#FFC83D',
          'on-secondary': '#1E1535',
          'secondary-darken-1': '#C98A00',
          'success-bright': '#3FD8A0',
          'on-success-bright': '#1E1535',
          'success-bright-darken-1': '#1E9E70',
          success: '#0B7A51',
          error: '#C9303A',
          info: '#1D4FA8',
          warning: '#7A5200',
          background: '#F5F2FF',
          surface: '#FFFFFF',
          'on-surface': '#1E1535',
          'on-surface-variant': '#5E5577',
          outline: '#E7E1F7',
          'surface-variant': '#F1EDFB'
        }
      },
      dark: {
        dark: true,
        colors: {
          primary: '#9C7BFF',
          'on-primary': '#160F29',
          'primary-darken-1': '#6A4BD6',
          'primary-lighten-5': '#2E2350',
          secondary: '#FFD466',
          'on-secondary': '#160F29',
          'success-bright': '#3FD8A0',
          'on-success-bright': '#160F29',
          success: '#3FD8A0',
          'on-success': '#160F29',
          error: '#FF8A93',
          'on-error': '#160F29',
          info: '#8DB6FF',
          warning: '#FFD466',
          background: '#160F29',
          surface: '#22183D',
          'surface-variant': '#2E2350',
          'on-surface': '#F4F0FF',
          'on-surface-variant': '#BDB3DA',
          outline: '#3A2E5E'
        }
      }
    }
  },
  defaults: {
    VAppBar: {
      elevation: 0
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg'
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg'
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg'
    },
    VBtn: {
      rounded: 'lg',
      class: 'fb-chunky-auto'
    },
    VCard: {
      variant: 'outlined',
      border: 'md',
      elevation: 0,
      rounded: 'xl',
      class: 'fb-card-outline'
    },
    VChip: {
      rounded: 'pill'
    },
    VSnackbar: {
      location: 'bottom start'
    }
  }
})
